import { compose } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { format } from 'url';
import { withRouter } from 'react-router';
import { EVENT_TYPES } from '~/analytics/events';
import RootStoreContext from '~/contexts/RootStoreContext';
import { actions as analyticsActions } from '~/domains/analytics';
import { selectors as searchSelectors } from '~/domains/search';
import { ANG_SIDEBAR_CONSISTENCY_ENABLED } from '~/domains/featureFlags/keys';
import { selectors as featureFlagsSelectors } from '~/domains/featureFlags';
import { selectors as commonSelectors } from '~/domains/common';
import { parseSearch } from '~/utils/location';
import { getDefaultSort } from '~/utils/ang/sorting';
import {
  ACTIVE_ORGANIZATION_LINK_ID,
  ALL_ORGANIZATION_LINK_ID,
  ALL_ASSETS_LINK_ID
} from '~/utils/navigation/constants';
import Sorting from './Sorting';

const mapStateToProps = (state, { location }) => {
  const isANGSidebarConsistencyEnabled = featureFlagsSelectors.featureFlag(
    state,
    ANG_SIDEBAR_CONSISTENCY_ENABLED
  );
  const query = parseSearch(location.search);
  const profile = commonSelectors.profile(state);
  const isAuthenticated = !!profile;

  const defaultSort = getDefaultSort({
    isANGSidebarConsistencyEnabled,
    isAuthenticated,
    show: query.show
  });

  return {
    sort: query.sort || defaultSort,
    show: query.show,
    search: query.search,
    defaultSort,
    isANGSearchEnabled: searchSelectors.isANGSearchEnabled(state),
    isANGSidebarConsistencyEnabled,
    isAuthenticated,
    profile
  };
};

const mapDispatchToProps = (dispatch, { location }) => {
  const query = parseSearch(location.search);

  return {
    onChange: (sort, isANGSidebarConsistencyEnabled, profile) => {
      const newQuery = { ...query, sort };
      const isLandingPage = Object.keys(query).length === 0;
      const masterOrganization = profile?.organization;
      const onlyOneBG = !masterOrganization?.subOrganizationIds?.length;

      if (isANGSidebarConsistencyEnabled && !newQuery.show && profile) {
        if (isLandingPage) {
          if (onlyOneBG) {
            newQuery.show = ACTIVE_ORGANIZATION_LINK_ID;
          } else {
            newQuery.show = ALL_ORGANIZATION_LINK_ID;
          }
        } else {
          newQuery.show = ALL_ASSETS_LINK_ID;
        }
      }

      const newURL = format({
        pathname: location.pathname,
        query: newQuery
      });

      dispatch(
        analyticsActions.trackEvent(EVENT_TYPES.SORTING_CHANGE, { sort })
      );
      dispatch(push(newURL));
    }
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onChange: (sort) =>
    dispatchProps.onChange(
      sort,
      stateProps.isANGSidebarConsistencyEnabled,
      stateProps.profile
    )
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, mergeProps, {
    context: RootStoreContext
  })
)(Sorting);
